import React from "react"
import PropTypes from "prop-types"
import { Box } from "@infotech/uikit-grid"
import styles from "./styles.css"

const ExternalLink = ({ data: { uri, name } }) => (
  <Box loose mb="-2md">
    <p className={styles.Link}>
      <a href={uri}>{name}</a>
    </p>
  </Box>
)

ExternalLink.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    uri: PropTypes.string,
  }),
}

ExternalLink.defaultProps = {
  data: {
    name: null,
    uri: null,
  },
}

export default ExternalLink
